import script from "./NewCusDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./NewCusDialog.vue?vue&type=script&setup=true&lang=js"

import "./NewCusDialog.vue?vue&type=style&index=0&id=c055f264&lang=scss&scoped=true"

import exportComponent from "/Users/ilss0902/PorjectCenter/Cloudmobile/雲端POS_V2/code/dayungs_pos_web/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c055f264"]])

export default __exports__